import React from 'react'
// @src imports
import { UiCard } from 'src/chrome'

interface SharingInfoCardProps {}

const SharingInformationCard: React.FC<SharingInfoCardProps> = props => {
  const { children } = props
  return <UiCard title={'Sharing Information'}>{children}</UiCard>
}

export default SharingInformationCard
